
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.83 9.17H6.17l3.584-4.408a.837.837 0 00-1.183-1.184l-5 5.834a.834.834 0 00-.175.275.833.833 0 000 .633c.04.102.099.196.175.275l5 5.833a.833.833 0 001.183 0 .832.832 0 000-1.183l-3.583-4.408h9.658a.833.833 0 000-1.667z","fill":"currentColor"}})])
          )
        }
      }
    